import { AppSettingContextData } from '@contexts/appSetting/AppSettingContext';
import { AppSetting } from '@ul/appsetting-model';
import { WhiteLabelSetting } from '@ul/whitelabel-setting';
import { mergeAppSettingWithWhiteLabelSetting } from './mergeAppSettingWithWhiteLabelSetting';

export function buildAppSetting(root: HTMLElement): AppSettingContextData {
    const dataset = root?.dataset;
    const appContextFromSetting = getAppSetting(dataset);
    const whitelabelConfig = getWhiteLabelConfig(dataset);

    return mergeAppSettingWithWhiteLabelSetting(appContextFromSetting, whitelabelConfig);
}

const getAppSetting = (dataset: DOMStringMap): AppSetting => {
    const dataFromRoot = <TKey extends keyof AppSetting>(key: TKey): AppSetting[TKey] | undefined => {
        const data = !!dataset ? dataset[key] : undefined;

        if (data === undefined || data === '') {
            return undefined;
        }

        try {
            return JSON.parse(data) as AppSetting[TKey];
        } catch {
            return undefined;
        }
    };

    return {
        features: dataFromRoot('features'),
        customUI: dataFromRoot('customui' as 'customUI'),
        grantType: dataFromRoot('granttype' as 'grantType'),
    };
};

const getWhiteLabelConfig = (dataset: DOMStringMap): WhiteLabelSetting | undefined => {
    const jsonString = !!dataset ? dataset['whitelabelSetting'] : undefined;

    if (jsonString === undefined) {
        return undefined;
    }

    try {
        return (JSON.parse(jsonString) as WhiteLabelSetting) || undefined;
    } catch {
        return undefined;
    }
};
